export default {
  title: '协议',
  subtitle: 'Titron Protocol',
  description: '为Web3构建保护隐私和数据主权的基石协议，让数据在可验证的前提下安全共享和利用价值',
  layers: {
    privacyLayer: {
      title: '隐私保护层',
      subtitle: 'Privacy Protection Layer',
      description: '零知识证明和同态加密技术，实现数据可验证而不可见'
    },
    identityLayer: {
      title: '数据身份层',
      subtitle: 'Data Identity Layer',
      description: '去中心化身份管理，用户拥有完整的数字主权'
    },
    economyLayer: {
      title: '智能经济层',
      subtitle: 'Smart Economy Layer',
      description: '隐私保护的智能合约，构建去中心化数据交易市场'
    },
    interopLayer: {
      title: '互联层',
      subtitle: 'Interoperability Layer',
      description: '跨链兼容，将隐私保护能力扩展到整个多链生态'
    }
  },
  principles: {
    title: '设计原则',
    privacyFirst: {
      title: 'Privacy First',
      description: '隐私优先',
      detail: '将用户隐私保护作为协议设计的首要原则'
    },
    userSovereignty: {
      title: 'User Sovereignty',
      description: '用户主权',
      detail: '用户完全控制自己的数据和身份'
    },
    verifiableComputing: {
      title: 'Verifiable Computing',
      description: '可验证计算',
      detail: '确保计算结果的正确性和可验证性'
    },
    decentralization: {
      title: 'Decentralization',
      description: '去中心化',
      detail: '没有单点故障，抗审查和控制'
    }
  },
  architecture: {
    title: '架构设计',
    heading: '分层架构设计',
    description: 'Titron协议采用分层架构设计，每一层都有明确的职责和功能'
  },
  cta: {
    title: '开始使用Titron协议',
    description: '加入我们的开发者社区，开始构建隐私保护的Web3应用',
    button: '开始构建'
  }
};
